import { jsx as _jsx } from "react/jsx-runtime";
import { RegularCartPrices } from "./RegularCartPrices";
import { TrialsPrices } from "./TrialsPrices";
const Prices = ({ isFreeTrial = false, prices, isSummary = false }) => {
    if (prices) {
        if (!isFreeTrial) {
            return _jsx(RegularCartPrices, { prices: prices, isSummary: isSummary });
        }
        return _jsx(TrialsPrices, { ...prices, isSummary: isSummary });
    }
    return null;
};
export default Prices;
//# sourceMappingURL=Prices.js.map